import { ErrorMessage } from './error-message.interface';

export const errorMessageData: ErrorMessage[] = [
    {
        statusCode: '0000',
        title: 'Terjadi Kesalahan',
        description: 'Silakan coba lagi dengan tap tombol di bawah ini.',
        image: 'assets/images/failed.svg',
        firstButton: {
            isBgRed: true,
            text: 'Coba lagi',
            url: ''
        }
    },
    {
        statusCode: '40311',
        title: 'Program Sudah Berakhir',
        description: 'Kamu bisa cek program menarik lainnya dari Telkomsel',
        image: 'assets/images/expired_promo.svg',
        firstButton: {
            isBgRed: true,
            text: 'Kembali',
            url: ''
        }
    },
    {
        statusCode: '40404',
        title: 'Program Tidak Ditemukan',
        description: 'Kamu bisa cek program menarik lainnya dari Telkomsel',
        image: 'assets/images/not_found.svg',
        firstButton: {
            isBgRed: true,
            text: 'Kembali',
            url: ''
        }
    },
    {
        statusCode: '40405',
        title: 'Penawaran tidak tersedia',
        description: 'Maaf,tidak ada penawaran yang tersedia untuk nomor Anda atau Telkomsel Poin Anda tidak cukup.',
        image: 'assets/images/not-eligible-number.png',
        firstButton: {
            isBgRed: false,
            text: 'Cek Penawaran Sejenis',
            url: 'https://www.telkomsel.com/promo'
        },
        secondButton: {
            isBgRed: true,
            text: 'Coba Nomor Lainnya',
            url: ''
        }
    }
];